/** Merge a delayed snapshot without discarding newer live events; newest first and bounded. */
export function mergeRecent<T>(current: readonly T[], snapshot: readonly T[], time: (item: T) => number, limit: number): T[] {
  const byTime = new Map<number, T>();
  for (const item of [...current, ...snapshot]) {
    const at = time(item);
    if (!byTime.has(at)) byTime.set(at, item);
  }
  return [...byTime.entries()].sort(([a], [b]) => b - a).slice(0, limit).map(([, item]) => item);
}
